export function getFilterValues(field: string): Array<string> {
  const params = new URLSearchParams(window.location.search);
  const filterValues: string[] = [];

  for (const [param, value] of params.entries()) {
    if (param === 'q' && field === param) {
      filterValues.push(value);
      break;
    }

    if (param.startsWith('filters[') && param.endsWith('][field]')) {
      const index = param.match(/\[(\d+)\]\[field\]$/)?.[1];
      if (index) {
        const filterField = params.get(`filters[${index}][field]`);

        if (filterField === field) {
          const valuesPrefix = `filters[${index}][values][0]`;
          let i = 0;
          let filterValue;
          do {
            filterValue = params.get(`${valuesPrefix}[${i}]`);
            if (filterValue !== null) {
              filterValues.push(filterValue);
            }
            i++;
          } while (filterValue !== null);
        }
      }
    }
  }

  return filterValues;
}

export function setFilterValue(field: string, value: string) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  urlSearchParams.set(field, value);

  window.history.pushState(null, '', `?${urlSearchParams.toString()}`);
}
